export class Proc_HandleInvtModel {
    item_desc: string;
    unit_price: number;
    admin_route: string;
    smallest_unit: number;
    item_tax1: boolean;
    item_base_charge: string;

    constructor(
        item_desc: string,
        unit_price: number,
        admin_route: string,
        smallest_unit: number,
        item_tax1: boolean,
        item_base_charge: string
    ) {
        this.item_desc = item_desc;
        this.unit_price = unit_price;
        this.admin_route = admin_route;
        this.smallest_unit = smallest_unit;
        this.item_tax1 = item_tax1;
        this.item_base_charge = item_base_charge;
    }
}